import { Component, Input, HostListener, forwardRef, OnInit } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';

type Item = {
	type: string,
	label: string,
	min: string,
	max: string,
	description: string
};

@Component({
	selector: 'app-dropdown-counter-input',
	templateUrl: './dropdown-counter-input.indra.component.html',
	styleUrls: ['./dropdown-counter-input.component.scss'],
	host: { class: 'app-dropdown-counter-input' },
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => INDRADropdownCounterInputComponent)
		}
	]
})
export class INDRADropdownCounterInputComponent implements OnInit{

	@Input() group: FormGroup;

	@Input() arialabel = 'Add or remove itens for your countdown';

	@Input() label = 'Passengers';

	@Input() icon: { svg: string, label: string } = { svg: 'tickets--adult_passenger', label: 'Passengers icon' };

	@Input() items: Array<Item>;

	setIncrementToDisable = {
		adults: false,
		children: false
	};

	setDecrementToDisable = {
		adults: false,
		children: false
	};

	showDropdown: boolean = false;

	isAlive: boolean = true;
	private wasInside = false;

	constructor() {
	}

	ngOnInit() {
		this.group.valueChanges
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(form => {
				if (form) {
					Object.keys(form).forEach(key => {
						const item = this.items.find(x => x.type === key);
						item.max === form[key] ? this.setIncrementToDisable[key] = true : this.setIncrementToDisable[key] = false;
						item.min === form[key] ? this.setDecrementToDisable[key] = true : this.setDecrementToDisable[key] = false;
					});
				}
			});
	}

	@HostListener('click')
	clickInside() {
		this.wasInside = true;
	}

	@HostListener('document:click')
	clickout() {
		if (!this.wasInside) {
			this.showDropdown = false;
		}
		this.wasInside = false;
	}

	INDRA_handleAddClick() {
		this.showDropdown = !this.showDropdown;
	}

	INDRA_itemsMax(type) {
		return this.INDRA_itemsTotal() < 9 ? 9 : 0;
	}

	/**
	 * Compute passenger total. Used in the template to show the passenger total
	 */
	INDRA_itemsTotal() {
		let total = 0;
		for (const type in this.group.value) {
			total += this.group.value[type];
		}
		return total;
	}

	INDRA_printCount() {
		let label = '';
		let index = 0;
		for (const type in this.group.value) {
			if (this.group.value[type] > 0) {
				label += this.group.value[type] + ' ' + this.items[index].label + ', ';
			}
			index++;
		}
		return label.substring(0, label.length - 2);
	}
}
